export default __webpack_public_path__ + "static/media/notFoundBg.4014f05f.png";